import _taggedTemplateLiteral from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";

var _templateObject;

import { gql } from "graphql-tag";
import GraphQLJSON, { GraphQLJSONObject } from "graphql-type-json";
export var typeDef = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  directive @cacheControl(\n    maxAge: Int\n    scope: CacheControlScope\n  ) on OBJECT | FIELD | FIELD_DEFINITION\n\n  enum CacheControlScope {\n    PUBLIC\n    PRIVATE\n  }\n\n  scalar JSON\n  scalar JSONObject\n\n  type Genre {\n    id: ID!\n    name: String!\n  }\n\n  type PageInfo {\n    offset: Int\n    limit: Int\n    totalCount: Int\n    hasNextPage: Boolean\n    hasPreviousPage: Boolean\n  }\n"])));
export var resolvers = {
  JSON: GraphQLJSON,
  JSONObject: GraphQLJSONObject
};